import React from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';

export function VerifyEmail() {
  const {user, resendEmailVerification} = useAuthContext()

  return (
    <Grid
      container
      rowSpacing={2}
      direction="column"
      justifyContent="center"
      alignItems="center"
      height="calc(100vh - 74px)"
    >
      <Grid
        item
        xs={12}
        display="flex"
        direction="column"
        justifyContent="center"
      >
        <Typography variant="h3" sx={{ mb: 1 }}>
          Please check your email!
        </Typography>

        <Stack spacing={1} sx={{ color: 'text.secondary', typography: 'body2', mb: 5 }}>
          <Box component="span"> We have sent a confirmation link to</Box>
          <Box component="strong" sx={{ color: 'text.primary' }}>
            {user?.firebaseUser?.email}
          </Box>
          <Box component="div">Please check your inbox/spam.</Box>
          <Box component="div"><Button variant='text' color="primary" sx={{ width: 50 }} onClick={() => resendEmailVerification()}>Resend</Button></Box>
          
        </Stack>
      </Grid>
    </Grid>
  );
}
